var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:phone-line",
    clipPath: "url(#clip0_589_11238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3957 21.1056C16.5223 26.2323 21.273 26.7936 22.6677 26.8456C24.353 26.907 26.073 25.531 26.817 24.1216C25.6303 22.7296 24.085 21.6496 22.3917 20.479C21.3943 21.4763 20.165 23.3296 18.525 22.6656C17.593 22.291 15.2917 21.231 13.281 19.219C11.269 17.2083 10.2103 14.907 9.83301 13.9763C9.16901 12.335 11.0277 11.1016 12.0263 10.103C10.8557 8.38295 9.79434 6.79762 8.40501 5.67095C6.97567 6.41762 5.59167 8.12429 5.65434 9.83229C5.70634 11.227 6.26767 15.9776 11.3957 21.1056ZM22.569 29.5096C20.649 29.439 15.2077 28.6883 9.50901 22.9896C3.81167 17.2923 3.06101 11.8523 2.98901 9.93095C2.88234 7.00295 5.12501 4.15895 7.71567 3.04829C8.02764 2.91358 8.36928 2.86229 8.70705 2.89945C9.04482 2.93662 9.36713 3.06097 9.64234 3.26029C11.7863 4.82429 13.265 7.19362 14.5357 9.04962C14.8 9.43556 14.9211 9.90176 14.878 10.3675C14.8349 10.8333 14.6303 11.2694 14.2997 11.6003L12.4917 13.4096C12.9117 14.3363 13.7663 15.9336 15.1663 17.3336C16.5663 18.7336 18.1637 19.5883 19.0917 20.0083L20.8983 18.2003C21.2305 17.8689 21.6684 17.6646 22.1357 17.623C22.603 17.5813 23.0701 17.7049 23.4557 17.9723C25.349 19.2843 27.573 20.7416 29.1943 22.8176C29.4098 23.0948 29.5469 23.4248 29.5913 23.7731C29.6356 24.1215 29.5855 24.4753 29.4463 24.7976C28.3303 27.4016 25.5063 29.6176 22.569 29.5096Z",
    fill: "#00C46B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_11238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelContact);
export default __webpack_public_path__ + "static/media/telContact.48fd19395220fbf393c2ab363a51c14b.svg";
export { ForwardRef as ReactComponent };